import { render, staticRenderFns } from "./ViewResearch.vue?vue&type=template&id=aa11da34&scoped=true"
import script from "./ViewResearch.vue?vue&type=script&lang=js"
export * from "./ViewResearch.vue?vue&type=script&lang=js"
import style0 from "./ViewResearch.vue?vue&type=style&index=0&id=aa11da34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa11da34",
  null
  
)

export default component.exports